import { render, staticRenderFns } from "./WindowSiteManager.vue?vue&type=template&id=0fffac6e&"
import script from "./WindowSiteManager.vue?vue&type=script&lang=js&"
export * from "./WindowSiteManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports